import { createRouter, createWebHashHistory, type RouteLocationNormalized } from "vue-router";
import routes from "./routes";
import { useCachedViewStoreHook } from "@/store/modules/cached-view";
import NProgress from "@/utils/progress";
import setPageTitle from "@/utils/set-page-title";
import { callAppMethod } from "@/utils/logistics-inquiry";

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export interface toRouteType extends RouteLocationNormalized {
  meta: {
    title?: string;
    noCache?: boolean;
  };
}

router.beforeEach((to: toRouteType, from, next) => {
  if (to.path !== "/scan-code-login") {
    NProgress.start();
  }
  // 路由缓存
  useCachedViewStoreHook().addCachedView(to);
  // 页面 title
  setPageTitle(to.meta.title);
  next();
});

router.afterEach(() => {
  NProgress.done();
});

/**
 * 拦截路由返回逻辑
 * 仅当在首页（history.state.back 为空）尝试执行返回操作时，调用原生 exitWebview
 * 其他情况均执行 vue-router 的原生返回逻辑
 */
const originalBack = router.back;
router.back = () => {
  if (window.history.state && window.history.state.back === null) {
    callAppMethod("exitWebview");
  } else {
    originalBack.call(router);
  }
};

const originalGo = router.go;
router.go = (delta: number) => {
  // 仅处理后退一步的操作
  if (delta === -1 && window.history.state && window.history.state.back === null) {
    callAppMethod("exitWebview");
  } else {
    originalGo.call(router, delta);
  }
};

export default router;
